import React from "react";
import infoCert from "../../assets/images/infocert.png";
import Palladium from "../../assets/images/palladiumGroup.png";
import ARC from "../../assets/images/perl.png";
import FMMFB from "../../assets/images/fmmfb.png";
import koboWeb from "../../assets/images/koboweb.png";
import Scl from "../../assets/images/scl.png";
const Patners = () => {
  const data = [
    {
      name: "Palladium Group Nigeria",
      logo: Palladium,
    },
    {
      name: "ARC By DAI",
      logo: ARC,
    },
    {
      name: "First Multiple MFB Ltd",
      logo: FMMFB,
    },
    {
      name: "KoboWeb GreenTech Group Ltd",
      logo: koboWeb,
    },
    {
      name: "Sa'I’ Anwara'I Ju'Mai Consultaire Limited (SCL)",
      logo: Scl,
    },
    {
      name: "SCL Project Juriya",
      logo: Scl,
    },
  ];
  return (
    <div
      style={{ background: "#293586" }}
      className="w-full text-white lg:px-0 md:px-32 px-10 py-8"
    >
      <div className="flex items-center justify-center">
        <div className="w-full h-[0.5px] bg-white" />
        <h1 className="text-3xl font-light px-10">Clients</h1>
        <div className="w-full h-[0.5px] bg-white" />
      </div>
      <center>
        {/*  */}
        {/* lg:flex md:grid md:grid-cols-5 sm:grid-cols-2 items-center justify-center  */}
        <div
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 place-items-center items-center justify-around my-5"
          style={{ margin: "auto" }}
        >
          {data.map((item, index) => (
            <div key={index} style={{ width: 150 }} className="mx-5 my-5">
              <div
                style={{
                  backgroundColor: "white",
                  height: 80,
                  width: 80,
                  borderRadius: "100%",
                }}
              >
                <img
                  src={item.logo}
                  style={{
                    height: "100%",
                    width: "100%",
                    borderRadius: "100%",
                  }}
                />
              </div>
              <div style={{ width: 100 }}>
                <p className="text-xs mt-4 text-center my-5">{item.name}</p>
              </div>
            </div>
          ))}
          {/* First Item */}
          {/* <div className="md:pr-10 my-5  md:border-r border-r-white ">
            <div style={{ width: "150px" }} className="bg-white p-2 rounded-sm">
              <img src={infoCert} alt="Info Cert" />
            </div>
          </div> */}
          {/* Second Item */}
          {/* <div className=" px-5 my-5">
            <h1 className="text-4xl font-light">
              Kobo<span className="font-bold">web</span>
            </h1>
          </div> */}
          {/* Third Item */}
          {/* <div className="my-5 px-5 md:border-l border-l-white md:border-r border-r-white ">
            <h1 className="font-black text-5xl">Turgl</h1>
            <h1 className="font-light text-2xl">Technologies</h1>
          </div> */}
          {/* Fourth Item */}
          {/* <div className="my-5 px-5">
            <h1 className="text-4xl font-light">
              Super<span className="font-bold">CAD</span>
            </h1>
          </div> */}
        </div>
      </center>
    </div>
  );
};

export default Patners;
